module.exports = __webpack_public_path__ + "img/logos_sicily.1e371fc3.png";